// Enabler E7-C (ADO-2274), D-1: what changes when the selected ordering entry does.
//
// A product's row, and whether the caller sees it at all, depend on the entry's range. The stores
// that cache catalogue reads by SKU therefore hold answers for ONE entry, so a change of entry
// (the switcher, a depot switch, a sign-in choice) resets them: the product page's product and
// detail, and the substitute and recommendation rails. The components that read them re-invoke
// their loads on the same change (`useCatalogueEntryKey` in their effect dependencies), and each
// reset's generation bump drops a fetch for the old entry that lands late.
//
// Favourites are a person's list, not a cache by entry, so they are re-read rather than reset:
// with an entry, each product is summarised from its row in that entry's range.
//
// Wired once at the composition root (main.tsx), beside the favourites boot hydration, so no
// component spec is coupled to it.

import { useAuthStore } from '../auth/useAuthStore';
import { useSessionStore } from '../auth/useSessionStore';
import { useFavouritesStore } from '../favourites/useFavouritesStore';
import { useProductDetailStore } from '../product-detail/useProductDetailStore';
import { useRecommendationsStore } from '../recommendations/useRecommendationsStore';
import { useSubstitutesStore } from '../substitutes/useSubstitutesStore';

/** Subscribe to the session's active entry; returns the unsubscribe handle. */
export function startCatalogueEntryResets(): () => void {
  let previous = useSessionStore.getState().activeEntryKey;
  return useSessionStore.subscribe((state) => {
    const next = state.activeEntryKey;
    if (next === previous) return;
    previous = next;
    useProductDetailStore.getState().reset();
    useSubstitutesStore.getState().reset();
    useRecommendationsStore.getState().reset();
    const { status, isAuthenticated } = useAuthStore.getState();
    if (next !== null && status === 'ready' && isAuthenticated) {
      void useFavouritesStore.getState().hydrate();
    }
  });
}
